import BaseDataObject from './BaseDataObject';

// ---------------------------------------- Reduction "Abstract" Class ----------------------------------------
export default class BaseReduction extends BaseDataObject {
  reset() {
    let any = false;
    for (const name in this.data) {
      any = true;
      delete this.data[name];
    }
    if (any) {
      this.invalidate();
    }
  }

  isDisabled() {
    return this.getBoolean('disabled');
  }

  toggleDisabled() {
    return this.setDisabled(!this.isDisabled());
  }

  setDisabled(v) {
    this.invalidate();
    return this.setBoolean('disabled', v);
  }
}
